<template>
    <a-layout id="page_code" class="page_layout page_tool">
        <a-layout-content class="page_content">
            <cTabs tabsType="line" :tabsData="tabsData" @backTabs="backTabs">
                <div class="tab_wrap" v-if="tabsCurr && tabsCurr.tabKey === 1">
                    <template v-if="!createBtn">
                        <div class="tab_title">
                            <a-alert :message="tabsCurr.tabDesc" type="info" />
                        </div>
                        <a-button type="primary" class="tab_btn" @click="createCode">
                            新建{{ tabsCurr.tabName }}
                        </a-button>
                        <a-button type="link" @click="toPath('/code-help')">
                            员工码帮助文档
                            <a-icon type="question-circle" />
                        </a-button>
                        <a-divider />
                        <!-- 员工码列表 -->
                        <div class="staff_list">
                            <div class="table_data">
                                <a-table
                                    rowKey="id"
                                    :columns="staffColumns"
                                    :data-source="staffList"
                                    :pagination="staffPage"
                                    @change="changePagination"
                                >
                                    <template slot="type" slot-scope="text">
                                        <template v-if="text === 1">单人</template>
                                    </template>
                                    <template slot="skipVerify" slot-scope="text">
                                        <template v-if="text === 0">手动验证</template>
                                        <template v-else-if="text === 1">自动验证</template>
                                    </template>
                                    <template slot="action" slot-scope="text, record">
                                        <a-button-group
                                            style="margin-left: -7px;"
                                            class="cross_center"
                                        >
                                            <a-button
                                                type="link"
                                                @click="downloadImg(record)"
                                                size="small"
                                                >下载</a-button
                                            >
                                            <a-divider type="vertical" />
                                            <a-button
                                                type="link"
                                                @click="editStaff(record)"
                                                size="small"
                                                >修改</a-button
                                            >
                                            <a-divider type="vertical" />
                                            <a-button
                                                type="link"
                                                @click="staffDel(record)"
                                                size="small"
                                                >删除</a-button
                                            >
                                        </a-button-group>
                                    </template>
                                </a-table>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- 创建员工码 -->
                        <a-page-header
                            :title="
                                (tabsCurr.createCodeData.qrcodeId ? '修改' : '新建') +
                                    tabsCurr.tabName
                            "
                            @back="createBack"
                            class="edit_code_title"
                        />
                        <div class="edit_code_from">
                            <a-form-model
                                ref="ruleForm1"
                                :model="tabsCurr.createCodeData"
                                :rules="tabsCurr.fromRule"
                                :label-col="{ span: 4 }"
                                :wrapper-col="{ span: 20 }"
                                labelAlign="left"
                            >
                                <div class="main_between cross_top">
                                    <div class="left_col">
                                        <a-form-model-item label="类型" prop="type">
                                            <a-radio-group v-model="tabsCurr.createCodeData.type">
                                                <a-radio value="1">
                                                    单人
                                                </a-radio>
                                                <!-- <a-radio value="2" disabled>
                                                    批量单人
                                                </a-radio>
                                                <a-radio value="3" disabled>
                                                    多人
                                                </a-radio> -->
                                            </a-radio-group>
                                        </a-form-model-item>
                                        <a-form-model-item label="使用员工" prop="userId">
                                            <a-button class="staff_add" @click="toOpen">
                                                添加
                                            </a-button>
                                            <contactsModal
                                                ref="contacts"
                                                :title="['组织架构', '已选择成员']"
                                                backFunctionName="backUserList"
                                                type="single"
                                                :backFunctionData="true"
                                                @backUserList="backUserList"
                                            ></contactsModal>
                                            <div
                                                class="dir_left_wrap cross_center"
                                                v-if="
                                                    tabsCurr.createCodeData.userId &&
                                                        tabsCurr.createCodeData.userId.length > 0
                                                "
                                            >
                                                <div
                                                    class="base_font_size_14 base_font_color_606266"
                                                >
                                                    已选人员：
                                                </div>
                                                <template
                                                    v-for="(item, index) in tabsCurr.createCodeData
                                                        .userId"
                                                >
                                                    <a-tag
                                                        :key="index"
                                                        @click="tagClose('userId', index)"
                                                    >
                                                        <openData
                                                            type="userName"
                                                            :openid="item"
                                                        ></openData>
                                                        <a-icon type="close" />
                                                    </a-tag>
                                                </template>
                                            </div>
                                            <div
                                                class="dir_left_wrap cross_center"
                                                v-if="
                                                    tabsCurr.createCodeData.deptId &&
                                                        tabsCurr.createCodeData.deptId.length > 0
                                                "
                                            >
                                                <div
                                                    class="base_font_size_14 base_font_color_606266"
                                                >
                                                    已选部门：
                                                </div>
                                                <template
                                                    v-for="(item, index) in tabsCurr.createCodeData
                                                        .deptId"
                                                >
                                                    <a-tag
                                                        :key="index"
                                                        @click="tagClose('deptId', index)"
                                                    >
                                                        <openData
                                                            type="departmentName"
                                                            :openid="item"
                                                        ></openData>
                                                        <a-icon type="close" />
                                                    </a-tag>
                                                </template>
                                            </div>
                                        </a-form-model-item>
                                        <a-form-model-item label="添加设置" prop="skipVerify">
                                            <a-radio-group
                                                v-model="tabsCurr.createCodeData.skipVerify"
                                            >
                                                <a-radio value="0">
                                                    手动通过
                                                </a-radio>
                                                <a-radio value="1">
                                                    自动通过
                                                </a-radio>
                                                <!-- <a-radio value="2" disabled>
                                                    部分时段自动通过
                                                </a-radio> -->
                                            </a-radio-group>
                                        </a-form-model-item>
                                        <a-form-model-item label="渠道场景" prop="remark">
                                            <a-input
                                                v-model="tabsCurr.createCodeData.remark"
                                                :addon-after="
                                                    tabsCurr.createCodeData.overActiveNameNum +
                                                        '/30'
                                                "
                                                @change="
                                                    inputChange(
                                                        'remark',
                                                        30,
                                                        'overActiveNameNum',
                                                        'overActiveName'
                                                    )
                                                "
                                            />
                                            <div class="name_desc base_font_color_909399">
                                                {{ tabsCurr.createCodeData.staffActiveNameDesc }}
                                            </div>
                                            <!-- <div class="setting cross_center">
                                                <div class="setting_btn base_font_size_14" @click="booleanBtn('settingBtn')">
                                                    <a-icon type="caret-right" style="margin-right: 5px;" class="caret_right" :class="settingBtn ? 'active_bg' : ''" />
                                                    高级设置
                                                </div>
                                            </div> -->
                                        </a-form-model-item>
                                    </div>
                                    <div class="right_col">
                                        <div class="qrcode cross_center">
                                            <a-card
                                                hoverable
                                                class="qrcode_in main_center cross_center"
                                                style="width: 100%; height: 260px;"
                                                :bodyStyle="{
                                                    width: 'auto',
                                                    display: 'inline-block'
                                                }"
                                            >
                                                <a-icon
                                                    type="qrcode"
                                                    style="font-size: 50px;line-height: 1;"
                                                    v-if="!qrcode"
                                                />
                                                <img :src="qrcode" width="100%" v-else />
                                            </a-card>
                                        </div>
                                        <p
                                            class="wx_txt base_font_size_12 base_font_color_909399"
                                            style="line-height:3"
                                        >
                                            员工码
                                        </p>
                                    </div>
                                </div>
                                <a-divider style="background-color: #f3f3f3;" />
                                <template v-if="settingBtn">
                                    <div
                                        style="margin-bottom: 20px;"
                                        class="main_between cross_top"
                                    >
                                        <div class="left_col">
                                            <a-form-model-item label="扫码标签" prop="staffTag">
                                                <div>
                                                    <a-button
                                                        @click="toOpenTags"
                                                        style="margin-top: 5px;"
                                                    >
                                                        添加标签
                                                    </a-button>
                                                    <div
                                                        class="dir_left_wrap cross_center"
                                                        v-if="
                                                            tabsCurr.createCodeData.staffTag &&
                                                                tabsCurr.createCodeData.staffTag
                                                                    .length > 0
                                                        "
                                                    >
                                                        <div
                                                            class="base_font_size_14 base_font_color_606266"
                                                        >
                                                            已选标签：
                                                        </div>
                                                        <template
                                                            v-for="(item, index) in tabsCurr
                                                                .createCodeData.staffTag"
                                                        >
                                                            <a-tag
                                                                :key="index"
                                                                @click="tagClose('staffTag', index)"
                                                            >
                                                                {{ item.tagName
                                                                }}<a-icon type="close" />
                                                            </a-tag>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="name_desc base_font_color_909399">
                                                    {{ tabsCurr.createCodeData.staffTagDesc }}
                                                </div>
                                                <tagModal
                                                    ref="tags"
                                                    :selectKey="tabsCurr.createCodeData.staffTag"
                                                    @change="backTagList"
                                                />
                                            </a-form-model-item>
                                        </div>
                                        <div class="right_col">
                                            <wxHead :data="staffTagComputed"></wxHead>
                                        </div>
                                    </div>
                                    <a-divider style="background-color: #f3f3f3;" />
                                    <div class="main_between cross_top">
                                        <div class="left_col">
                                            <a-form-model-item label="欢迎语" prop="welcomeId">
                                                <a-radio-group
                                                    v-model="
                                                        tabsCurr.createCodeData.staffWelcomeType
                                                    "
                                                >
                                                    <a-radio value="1">
                                                        固定欢迎语
                                                    </a-radio>
                                                    <!-- <a-radio value="2" disabled>
                                                        分时段欢迎语
                                                    </a-radio> -->
                                                </a-radio-group>
                                                <div class="cross_center" style="line-height: 2;">
                                                    <div
                                                        class="base_font_size_14 base_font_color_ff5800 dir_left_wrap cross_center"
                                                        style="cursor: pointer;"
                                                        @click="
                                                            modalBtn('staffWelcomeTemplateModal')
                                                        "
                                                        v-if="
                                                            !tabsCurr.createCodeData
                                                                .staffWelcomeTemplateId
                                                        "
                                                    >
                                                        从欢迎语模板选取
                                                        <a-alert
                                                            message="原先模板失效，重新选择"
                                                            banner
                                                            v-if="welcomeTemplate"
                                                            style="margin-left: 5px;"
                                                        />
                                                    </div>
                                                    <div
                                                        class="cross_center"
                                                        v-else
                                                        style="margin-bottom: 10px;"
                                                    >
                                                        <a-button
                                                            type="primary"
                                                            icon="swap"
                                                            @click="
                                                                modalBtn(
                                                                    'staffWelcomeTemplateModal'
                                                                )
                                                            "
                                                            style="margin-right: 10px;"
                                                        >
                                                            重新选择模板
                                                        </a-button>
                                                        <a-button
                                                            icon="minus-circle"
                                                            @click="removeModel"
                                                        >
                                                            移除模板
                                                        </a-button>
                                                    </div>
                                                    <cModal
                                                        title="选择欢迎语"
                                                        :subName="{
                                                            modalName: 'staffWelcomeTemplateModal',
                                                            slotDataName: 'welcomeList',
                                                            child: 'isSelected',
                                                            valueName: 'welcomeId',
                                                            valueTo: 'staffWelcomeTemplateId'
                                                        }"
                                                        :visible="
                                                            tabsCurr.createCodeData
                                                                .staffWelcomeTemplateModal
                                                        "
                                                        backFunctionName="modalBtn"
                                                        :backFunctionData="true"
                                                        @modalBtn="modalBtn"
                                                    >
                                                        <wxWelcomeTemplate
                                                            tableRowKey="welcomeId"
                                                            tableTitle="title"
                                                            title="欢迎语列表"
                                                            :data="welcomeList"
                                                            :page="welcomePage"
                                                            :params="welcomeParams"
                                                            @backWelcomeParams="backWelcomeParams"
                                                        ></wxWelcomeTemplate>
                                                    </cModal>
                                                </div>
                                                <div class="welcome_container">
                                                    <!-- <wxWelcomeEdit
                                                        :changeParams="['staffWelcomeDesc', 100, 'overWelcomeDescNum', 'overWelcomeDesc']"
                                                        :data="tabsCurr.createCodeData"
                                                        @backTextarea="backTextarea"
                                                        @backWelcomeData="backWelcomeData"
                                                        v-if="!tabsCurr.createCodeData.staffWelcomeTemplateId"
                                                        style="margin-top: 16px;margin-bottom: 16px;"
                                                    >
                                                    </wxWelcomeEdit> -->
                                                    <div
                                                        v-if="
                                                            tabsCurr.createCodeData
                                                                .staffWelcomeTemplateId
                                                        "
                                                    >
                                                        {{
                                                            tabsCurr.createCodeData
                                                                .staffWelcomeTemplateId.title
                                                        }}
                                                    </div>
                                                </div>
                                            </a-form-model-item>
                                        </div>
                                        <div class="right_col">
                                            <wxWelcome :data="welcomeDataComputed"></wxWelcome>
                                        </div>
                                    </div>
                                </template>
                            </a-form-model>
                            <div class="affix_style">
                                <a-affix
                                    class="affix_wrapper"
                                    @change="affixChange"
                                    :style="collapsed ? 'left:110px' : 'left: 230px'"
                                >
                                    <a-space>
                                        <a-button type="primary" @click="createNew">
                                            {{ tabsCurr.createCodeData.qrcodeId ? '保存' : '新建' }}
                                        </a-button>
                                        <a-button @click="createBack">
                                            取消
                                        </a-button>
                                    </a-space>
                                </a-affix>
                            </div>
                        </div>
                    </template>
                </div>
                <groupChat
                    :show="tabsCurr && tabsCurr.tabKey === 2 ? true : false"
                    :message="tabsCurr && tabsCurr.tabKey === 2 ? tabsCurr.tabDesc : ''"
                    @backTabDisabled="backTabDisabled"
                />
            </cTabs>
        </a-layout-content>
    </a-layout>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import { mapState } from 'vuex';
import cTabs from '@/components/common/ant/c_tabs';
import cModal from '@/components/common/ant/c_modal';
import wxHead from '@/components/common/base/wx_head';
import wxWelcome from '@/components/common/base/wx_welcome';
// import wxWelcomeEdit from '@/components/common/base/wx_welcome_edit';
import wxWelcomeTemplate from '@/components/common/base/wx_welcome_template';
import contactsModal from '@/components/group/contactsModal';
import tagModal from '@/components/group/tagModal';
import openData from '@/components/group/openData';
import groupChat from '@/components/common/base/group_chat';
export default {
    name: 'page_code',
    components: {
        cTabs,
        cModal,
        wxHead,
        wxWelcome,
        // wxWelcomeEdit,
        wxWelcomeTemplate,
        contactsModal,
        tagModal,
        openData,
        groupChat
    },
    data() {
        return {
            // tabs数据
            tabsData: [
                {
                    tabKey: 1,
                    tabName: '员工码',
                    tabDesc: '通过扫描渠道码添加员工好友，自动给客户设置标签和发送欢迎语。',
                    tabDisabled: false,
                    createCodeData: {
                        qrcodeId: null,
                        // 类型
                        type: '1',
                        // 使用员工id
                        userId: [],
                        deptId: [],
                        // 添加设置
                        skipVerify: '0',
                        // 渠道场景
                        remark: '',
                        staffActiveNameDesc: '填写员工码的使用场景，便于后续管理查找',
                        overActiveName: null,
                        overActiveNameNum: 0,
                        // 客户标签
                        tagList: [],
                        tagId: [],
                        staffTag: [],
                        staffTagDesc: '根据使用场景做标签记录，扫码添加的客户，可以自动打上标签',
                        staffTagModal: false,
                        // 欢迎语类型
                        staffWelcomeType: '1',
                        // 欢迎语模板id
                        welcomeId: null,
                        staffWelcomeTemplateId: null,
                        staffWelcomeTemplateModal: false,
                        // 欢迎语
                        staffWelcomeDesc: null,
                        overWelcomeDesc: null,
                        overWelcomeDescNum: 0,
                        // 添加图片/网页/小程序消息 [img, link, wxapp]
                        staffWelcomeAdd: null,
                        // 分时段
                        staffWelcomeTime: []
                    },
                    fromRule: {
                        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
                        userId: [{ required: true, message: '请选择使用员工', trigger: 'change' }],
                        skipVerify: [
                            { required: true, message: '请选择添加设置类型', trigger: 'change' }
                        ],
                        remark: [{ required: true, message: '请输入渠道名称', trigger: 'change' }],
                        welcomeId: [{ required: true, message: '请选择模板', trigger: 'change' }]
                    }
                },
                {
                    tabKey: 2,
                    tabName: '客户群码',
                    tabDesc: '客户扫码加入群聊，群满200人后，自动切换另一个群聊。',
                    tabDisabled: false,
                    createCodeData: {},
                    fromRule: {}
                }
            ],
            // 当前tab数据
            tabsCurr: null,
            // 创建码
            createBtn: false,
            // 测试数据
            staffArr: [],
            // 初始图
            qrcode: null,
            // 是否展开
            settingBtn: true,
            // 传递欢迎语
            welcomeData: [
                {
                    id: 0,
                    info: '我通过了你的朋友验证请求，现在我们可以开始聊天了',
                    isShow: true
                }
            ],
            // 欢迎语模版相关
            welcomeList: [],
            welcomeParams: {
                // 渠道码欢迎语（from_qrcode），主动添加欢迎语（from_contact）
                welcomeType: 'from_qrcode',
                page: 1,
                keywords: null
            },
            welcomePage: {
                total: 0,
                pageSize: 10
            },
            // 更多筛选
            selectMoreText: {
                text: '更多筛选',
                status: false
            },
            // 员工码相关
            staffList: [],
            staffParams: {
                page: 1,
                keywords: null
            },
            staffPage: {
                total: 0,
                pageSize: 10
            },
            staffColumns: [
                {
                    title: '渠道名称',
                    dataIndex: 'remark'
                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    scopedSlots: { customRender: 'type' }
                },
                {
                    title: '验证类型',
                    dataIndex: 'skipVerify',
                    scopedSlots: { customRender: 'skipVerify' }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    width: 200
                }
            ],
            // 欢迎语模板失效时，为true
            welcomeTemplate: false,
            // 图钉
            affixed: false,
            // 标签
            tagList: []
        };
    },
    computed: {
        ...mapState({
            collapsed: (state) => state.collapsed
        }),
        welcomeDataComputed() {
            this.welcomeData.sort(this.welcomeDataSort('id'));
            return this.welcomeData;
        },
        staffTagComputed() {
            return this.tabsCurr.createCodeData.staffTag;
        }
    },
    mounted() {
        this.getStaffList();
        // 初始
        this.tabsData.forEach((item, index) => {
            if (index === 0) this.tabsCurr = item;
        });
    },
    watch: {
        welcomeData(val) {
            console.log('watch: welcomeData数据', val);
        }
    },
    methods: {
        // 获取员工码列表
        async getStaffList() {
            try {
                const res = await api.getStaffQcode(this.staffParams);
                if (res.code !== 0) return;
                this.staffList = res.rows;
                this.staffPage = {
                    total: res.count,
                    pageSize: 10
                };
            } catch (err) {
                console.log(err);
            }
        },
        // 获取欢迎语模板
        async getWelcomeList() {
            try {
                const res = await api.getWelcomeList(this.welcomeParams);
                if (res.code !== 0) return;
                res.rows.forEach((item) => {
                    item.isSelected = false;
                    return item;
                });
                this.welcomeList = res.rows && res.rows.length > 0 ? res.rows : [];
                this.welcomePage = {
                    total: res.count,
                    pageSize: res.pageSize
                };
            } catch (err) {
                console.log(err);
            }
        },
        // Tabs接收子组件数据
        backTabs(data) {
            this.tabsData.forEach((item) => {
                if (item.tabKey === data) {
                    this.tabsCurr = item;
                }
            });
        },
        // 创建码
        createCode() {
            this.createBtn = !this.createBtn;
            this.tabsData.forEach((item) => {
                if (this.tabsCurr.tabKey !== item.tabKey) item.tabDisabled = true;
                return item;
            });
        },
        // 返回 / 取消
        createBack() {
            // 恢复初始数据
            this.createBtn = !this.createBtn;
            this.tabsData.forEach((item) => {
                item.tabDisabled = false;
                return item;
            });
            // this.settingBtn = false;
            this.welcomeTemplate = false;
            // 用于清空恢复初始数据
            let tabsDataClear = [
                {
                    tabKey: 1,
                    tabName: '员工码',
                    tabDesc: '通过扫描渠道码添加员工好友，自动给客户设置标签和发送欢迎语。',
                    tabDisabled: false,
                    createCodeData: {
                        qrcodeId: null,
                        // 类型
                        type: '1',
                        // 使用员工id
                        userId: [],
                        deptId: [],
                        // 添加设置
                        skipVerify: '0',
                        // 渠道场景
                        remark: '',
                        staffActiveNameDesc: '填写员工码的使用场景，便于后续管理查找',
                        overActiveName: null,
                        overActiveNameNum: 0,
                        // 客户标签
                        tagId: [],
                        staffTag: [],
                        staffTagDesc: '根据使用场景做标签记录，扫码添加的客户，可以自动打上标签',
                        staffTagModal: false,
                        // 欢迎语类型
                        staffWelcomeType: '1',
                        // 欢迎语模板id
                        welcomeId: null,
                        staffWelcomeTemplateId: null,
                        staffWelcomeTemplateModal: false,
                        // 欢迎语
                        staffWelcomeDesc: null,
                        overWelcomeDesc: null,
                        overWelcomeDescNum: 0,
                        // 添加图片/网页/小程序消息 [img, link, wxapp]
                        staffWelcomeAdd: null,
                        // 分时段
                        staffWelcomeTime: []
                    },
                    fromRule: {
                        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
                        userId: [{ required: true, message: '请选择使用员工', trigger: 'change' }],
                        skipVerify: [
                            { required: true, message: '请选择添加设置类型', trigger: 'change' }
                        ],
                        remark: [{ required: true, message: '请输入渠道名称', trigger: 'change' }],
                        welcomeId: [{ required: true, message: '请选择模板', trigger: 'change' }]
                    }
                },
                {
                    tabKey: 2,
                    tabName: '客户群码',
                    tabDesc: '客户扫码加入群聊，群满200人后，自动切换另一个群聊。',
                    tabDisabled: false,
                    createCodeData: {},
                    fromRule: {}
                }
            ];
            tabsDataClear.forEach((item) => {
                if (item.tabKey === this.tabsCurr.tabKey) this.tabsCurr = item;
            });
            this.welcomeData = [
                {
                    id: 0,
                    info: '我通过了你的朋友验证请求，现在我们可以开始聊天了',
                    isShow: true
                }
            ];
            this.qrcode = null;
        },
        // Modal是否展开
        modalBtn(subName) {
            if (this.tabsCurr && Object.prototype.toString.call(subName) === '[object String]') {
                this.tabsCurr.createCodeData[subName] = !this.tabsCurr.createCodeData[subName];
                this.getWelcomeList();
                this.welcomeTemplate = false;
            } else if (
                this.tabsCurr &&
                Object.prototype.toString.call(subName) === '[object Object]'
            ) {
                const preData = this.tabsCurr.createCodeData;
                preData[subName.dataName.modalName] = !preData[subName.dataName.modalName];
                if (subName.status) {
                    this[subName.dataName.slotDataName].forEach((item) => {
                        if (
                            subName.dataName.child &&
                            subName.dataName.child === 'tag' &&
                            item[subName.dataName.child]
                        ) {
                            item[subName.dataName.child].forEach((childItem) => {
                                if (
                                    childItem.isSelected &&
                                    !this.arrFilter(
                                        preData[subName.dataName.tagArr],
                                        childItem,
                                        'tagId'
                                    )
                                ) {
                                    preData[subName.dataName.tagArr].push(childItem);
                                    preData.tagId.push(childItem.tagId);
                                }
                            });
                        } else if (
                            subName.dataName.child &&
                            subName.dataName.valueTo &&
                            subName.dataName.valueName &&
                            subName.dataName.child === 'isSelected' &&
                            item[subName.dataName.child]
                        ) {
                            this.removeModel();
                            preData[subName.dataName.valueTo] = item;
                            preData.welcomeId = item.welcomeId;
                            this.welcomeDetail(item);
                        }
                    });
                }
            }
        },
        // 过滤
        arrFilter(arr, checkData, checkName) {
            let returnValue = false;
            arr.forEach((arrItem, index) => {
                if (arrItem[checkName] === checkData[checkName]) {
                    return (returnValue = true);
                }
            });
            return returnValue;
        },
        // 输入框变化
        inputChange(type, num, objsub1, objsub2) {
            if (this.tabsCurr && type && num && objsub1 && objsub2) {
                let data = this.tabsCurr.createCodeData;
                let textLength = data[type].length;
                if (textLength <= num) data[objsub1] = textLength;
                if (textLength === num) data[objsub2] = data[type];
                else if (textLength > num) data[type] = data[objsub2];
                if (type === 'staffWelcomeDesc') {
                    if (this.welcomeData && this.welcomeData.length === 1) {
                        this.welcomeData.push({
                            id: 1,
                            type: 'text',
                            info: data[type],
                            isShow: true
                        });
                    } else {
                        this.welcomeData.forEach((item) => {
                            if (item.id === 1) item.info = data[type];
                            return item;
                        });
                    }
                }
            }
        },
        // [员工码]获取子组件数据
        backTextarea(subName1, subValue1, subName2, subValue2) {
            this.tabsCurr.createCodeData[subName1] = subValue1;
            this.tabsCurr.createCodeData[subName2] = subValue2;
        },
        backWelcomeData(welcomeData) {
            console.log('backWelcomeData', welcomeData);
            this.welcomeData = welcomeData;
        },
        backUserList(userList) {
            const dataCurr = this.tabsCurr.createCodeData;
            if (userList && userList.dataName) {
                userList.dataName.forEach((item) => {
                    if (Object.prototype.toString.call(item) === '[object String]') {
                        if (_.indexOf(dataCurr.userId, item) < 0) dataCurr.userId.push(item);
                    } else {
                        if (_.indexOf(dataCurr.deptId, item) < 0) dataCurr.deptId.push(item);
                    }
                });
            }
        },
        // 是否按钮
        booleanBtn(subName) {
            this[subName] = !this[subName];
        },
        // [欢迎语模板]获取子组件数据
        backWelcomeParams(params) {
            this.welcomeParams = params;
            this.getWelcomeList();
        },
        // 开启
        toOpen() {
            this.$refs.contacts.open();
        },
        toOpenTags() {
            this.$refs.tags.open();
        },
        // 更多筛选
        selectMore() {
            this.selectMoreText.text = this.selectMoreText.status ? '更多筛选' : '收起';
            this.selectMoreText.status = !this.selectMoreText.status;
        },
        // 下载图片
        async downloadImg(record) {
            if (!record || !record.id) return this.$message.error('下载员工码传参错误。');
            try {
                const res = await api.downLoadCode({ qrcodeId: record.id });
                if (!res) return;
                this.downImgFile(record.remark + '.png', res);
            } catch (err) {
                console.log(err);
            }
            // this.downloadIamge(record.qrCode, record.remark + '.png');
        },
        // 纯图片下载方法
        // downloadIamge(imgsrc, name) {
        //     let image = new Image();
        //     // 解决跨域 Canvas 污染问题
        //     image.setAttribute("crossOrigin", "anonymous");
        //     image.onload = function() {
        //         let canvas = document.createElement("canvas");
        //         canvas.width = image.width;
        //         canvas.height = image.height;
        //         let context = canvas.getContext("2d");
        //         context.drawImage(image, 0, 0, image.width, image.height);
        //         let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        //         let a = document.createElement("a"); // 生成一个a元素
        //         let event = new MouseEvent("click"); // 创建一个单击事件
        //         a.download = name || "未命名图片"; // 设置图片名称
        //         a.href = url; // 将生成的URL设置为a.href属性
        //         a.dispatchEvent(event); // 触发a的单击事件
        //     };
        //     image.src = imgsrc;
        // },
        // 文件流下载方法
        downImgFile(file_name, content) {
            const csvData = new Blob([content]);
            // for IE
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(csvData, file_name);
            }
            // for Non-IE (chrome, firefox etc.)
            else {
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                const url = window.URL.createObjectURL(csvData);
                a.href = url;
                a.download = file_name;
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        },
        // 删除员工码
        staffDel(record) {
            const that = this;
            that.$confirm({
                title: '确认删除"' + record.remark + '"？',
                icon: 'exclamation-circle',
                onOk() {
                    that.staffDelete(record);
                },
                onCancel() {}
            });
        },
        async staffDelete(record) {
            try {
                if (!record) return;
                const res = await api.delStaff({ qrcodeId: record.id });
                if (res.code !== 0) return;
                this.$message.success(`员工码删除成功。`);
                this.getStaffList();
            } catch (err) {
                console.log(err);
            }
        },
        // 生成员工码
        async createNew() {
            try {
                const data = this.tabsCurr.createCodeData;
                if (!data.type) return this.$message.error('请选择类型。');
                if (!data.userId || data.userId.length === 0)
                    return this.$message.error('请添加使用人员。');
                if (!data.skipVerify) return this.$message.error('请选择添加设置类型。');
                if (!data.remark) return this.$message.error('请输入渠道名称。');
                if (!data.welcomeId) return this.$message.error('请选择欢迎语模版。');
                const params = {
                    type: parseInt(data.type, 10),
                    remark: data.remark,
                    skipVerify: parseInt(data.skipVerify, 10),
                    userId: data.userId
                };
                if (data.tagId) params.tagId = data.tagId;
                if (data.welcomeId) params.welcomeId = parseInt(data.welcomeId, 10);
                if (data.qrcodeId) params.qrcodeId = parseInt(data.qrcodeId, 10);
                const res = await (data.qrcodeId
                    ? api.updateStaff(params)
                    : api.createStaff(params));
                if (res.code !== 0) return;
                this.$message.success(data.qrcodeId ? '保存成功。' : '成功新增员工码。');
                this.createBack();
                this.getStaffList();
            } catch (err) {
                console.log(err);
            }
        },
        // 欢迎语排序
        welcomeDataSort(property) {
            return function(obj1, obj2) {
                let value1 = obj1[property];
                let value2 = obj2[property];
                return value1 - value2;
            };
        },
        // 修改欢迎语
        async welcomeDetail(record) {
            if (!record) return;
            const res = await api.getWelcomeDetail(record);
            if (res.code !== 0) return;
            if (!res.content || !res.material) {
                this.tabsCurr.createCodeData.staffWelcomeTemplateId = null;
                this.welcomeTemplate = true;
                return this.$message.error('欢迎语模板失效，请重新选择');
            }
            this.tabsCurr.createCodeData.staffWelcomeTemplateId = {
                title: res.material.title
                    ? res.content + '[' + res.material.title + ']'
                    : res.content,
                welcomeId: res.welcomeId
            };
            const checkContent = {
                id: 1,
                type: 'text',
                info: res.content,
                isShow: true
            };
            if (!this.arrFilter(this.welcomeData, checkContent, 'id'))
                this.welcomeData.push(checkContent);
            const checkData = {
                id:
                    res.material.mediaType === 'image'
                        ? 2
                        : res.material.mediaType === 'link'
                        ? 3
                        : 4,
                type: res.material.mediaType,
                info:
                    res.material.mediaType === 'image' || res.material.mediaType === 'wxapp'
                        ? res.material.cover
                        : res.material.title,
                isShow: true,
                cover: res.material.cover,
                title: res.material.title,
                description: res.material.description
            };
            if (!this.arrFilter(this.welcomeData, checkData, 'id') && res.material.title)
                this.welcomeData.push(checkData);
            console.log(this.welcomeData);
        },
        // 移除模板
        removeModel() {
            this.tabsCurr.createCodeData.staffWelcomeTemplateId = null;
            this.tabsCurr.createCodeData.welcomeId = null;
            this.welcomeData = [
                {
                    id: 0,
                    info: '我通过了你的朋友验证请求，现在我们可以开始聊天了',
                    isShow: true
                }
            ];
        },
        // 修改员工码
        async editStaff(record) {
            if (!record) return;
            const dataCurr = this.tabsCurr.createCodeData;
            this.createCode();
            const res = await api.getStaffDetail({ qrcodeId: record.id });
            if (res.code !== 0) return;
            dataCurr.qrcodeId = record.id;
            dataCurr.welcomeId = res.welcomeId;
            dataCurr.remark = res.remark;
            dataCurr.overActiveNameNum = res.remark.length;
            dataCurr.skipVerify = res.skipVerify.toString();
            dataCurr.userId = res.user;
            this.qrcode = record.qrCode ? record.qrCode : '/static/img/qrcode.jpg';
            await this.getTag();
            if (res.tag && res.tag.length > 0) {
                let tags = [];
                this.tagList.map((item) => {
                    tags = tags.concat(item.tag);
                });
                dataCurr.staffTag = _.filter(tags, (n) => {
                    return res.tag.includes(n.tagId);
                });
                dataCurr.tagId = _.map(dataCurr.staffTag, 'tagId');
            }
            if (res.welcomeId) {
                dataCurr.staffWelcomeTemplateId = res.welcomeId;
                // this.tabsCurr.createCodeData.staffWelcomeTemplateId = {
                //     title: res.content + '[' + res.material.title + ']',
                //     welcomeId: res.welcomeId
                // };
                this.welcomeDetail({ welcomeId: res.welcomeId });
            }
        },
        // 获取标签
        async getTag() {
            try {
                const res = await api.getTag();
                if (res.code !== 0) return;
                this.tagList = res.tagGroup;
            } catch (err) {
                console.log(err);
            }
        },
        // 关闭标签
        tagClose(type, index) {
            const dataCurr = this.tabsCurr.createCodeData;
            dataCurr[type].splice(index, 1);
            if (type === 'staffTag') dataCurr.tagId.splice(index, 1);
        },
        // 标签回调
        backTagList(data) {
            this.tabsCurr.createCodeData.staffTag = data;
            this.tabsCurr.createCodeData.tagId = [];
            data.forEach((dataItem) => {
                this.tabsCurr.createCodeData.tagId.push(dataItem.tagId);
            });
        },
        affixChange() {
            this.affixed = !this.affixed;
        },
        // 客户群码回调
        backTabDisabled(data) {
            this.tabsData.forEach((item) => {
                if (item.tabKey !== this.tabsCurr.tabKey) {
                    item.tabDisabled = data;
                    return item;
                }
            });
        },
        changePagination(e) {
            this.staffParams.page = e.current;
            this.getStaffList();
        },
        // 跳转路由
        toPath(url) {
            if (url)
                this.$router.push({
                    path: url
                });
        }
    }
};
</script>

<style>
#page_code .edit_code_from {
    overflow: auto;
    height: calc(100vh - 368px);
}
#page_code .edit_code_from::-webkit-scrollbar {
    display: none;
}
#page_code .from_btn {
    padding: 10px 0;
    width: 100%;
    background-color: #fff;
}
#page_code .left_col {
    padding: 0 6% 0 0;
    width: calc(95% - 260px);
}
#page_code .right_col {
    width: 260px;
}
#page_code .from_btn_fix {
    /* position: fixed;
    right: 31px;
    bottom: 80px;
    width: calc(100% - 276px);
    padding: 10px 30px; */
}
#page_code .affix_style {
    width: 100%;
    height: 52px;
}
#page_code .affix_wrapper {
    position: fixed;
    bottom: 81px;
    right: 47px;
    background: #fff;
    padding: 10px 30px;
    transition: all 0.2s;
}
#page_code .tab_wrap .tab_title {
    margin-bottom: 15px;
}
#page_code .edit_code_title {
    border: 1px solid rgb(235, 237, 240);
    margin-bottom: 15px;
}
#page_code .setting_btn {
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
}
#page_code .setting_btn .caret_right {
    transition: all 0.3s ease 0s;
}
#page_code .setting_btn .caret_right.active_bg {
    transform: rotate(90deg);
}
#page_code .welcome_container {
    background-color: #fafafa;
    border-radius: 4px;
    padding: 0 16px;
    overflow: hidden;
}
#page_code .name_desc {
    line-height: 1.3;
    margin-top: 10px;
}
/* 列表 */
#page_code .staff_list .select_btn {
    width: 70%;
    margin-bottom: 15px;
}
#page_code .select_title {
    width: 100px;
    text-align: right;
    padding: 0 10px;
}
#page_code .select_cont {
    width: calc(100% - 100px);
    padding: 0 10px;
}
/* #page_code .ant-table-body {
    max-height: calc(100vh - 536px) !important;
    overflow-y: auto !important;
} */
</style>
